<template>
  <v-layout row>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs6>
        <app-reference
          v-model="unloadingCountry"
          :outline="true"
          class="mx-2 my-0"
          label="Страна прибытия"
          :height-field="44"
          resource="countries"
          component-name="Country"
          @input="entityChange"
        >
          >
        </app-reference>
      </v-flex>
      <v-flex xs6>
        <AddressSelect
          v-model="unloadingAddress"
          :outline="true"
          class="mx-2 my-0"
          label="Адрес места прибытия"
          resource="addresses"
          component-name="Address"
          parent-filter="countryId"
          :parent-id="entity.unloadingCountry ? entity.unloadingCountry.id : 0"
          :without-parent-lock="true"
          :height-field="44"
          @input="entityChange"
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: ["entity"],
  data() {
    return {
      unloadingCountry: null,
      unloadingAddress: null,
    };
  },
  watch: {
    unloadingAddress() {
      this.unloadingCountry = this.entity.unloadingCountry
        ? this.entity.unloadingCountry
        : this.entity.unloadingAddress && this.entity.unloadingAddress.country
          ? {
            id: this.entity.unloadingAddress.country.id,
            title: this.entity.unloadingAddress.country.title,
          }
          : null;
    },
  },
  created() {
    if (this.entity) {
      this.unloadingCountry = this.entity.unloadingCountry;
      this.unloadingAddress = this.entity.unloadingAddress;
    }
  },
  methods: {
    entityChange() {
      this.$emit("change", {
        unloadingCountry: this.unloadingCountry,
        unloadingAddress: this.unloadingAddress,
      });
    },
  },
};
</script>
